import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import {useHandleClick} from "../../utils/clickHandlers"
import useHeroSectionStyles from './heroSectionStyle';

//Webapp Hero section
const HeroSection = () => {
  const classes = useHeroSectionStyles();
  const handleClick = useHandleClick();

  return (
    <Box className={classes.heroSection}>
      {/* Overlay for dark effect */}
      <div className={classes.overlay}></div>

      {/* Content */}
      <Box className={classes.content}>
        <Typography variant="h4" className={classes.heading}>
          From forgotten to vibrant
        </Typography>
        <Typography variant="body1" className={classes.text}>
          Paketposthalle is transforming into a vibrant hub, where history meets modern design.
          Explore the design through our dual-viewer platform.
        </Typography>
        <Box className={classes.buttonContainer}>
            <Button
              variant="contained"
              className={classes.exploreButton}
              onClick={(event) => handleClick(event, 'viewerToggle')}
            >
              Explore the Model
            </Button>
            <Button
              variant="outlined"
              className={classes.readMoreButton}
              onClick={(event) => handleClick(event, 'project')}
              >
              Read More..
            </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;